/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export class DeviceDetector {
  static isTouchDevice(): boolean {
    return "ontouchstart" in window;
  }

  static isMobileDevice = (): boolean => {
    // Check 1: User agent (basic but can be spoofed)
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

    // Check 2: Touch support (DevTools usually has this)
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Check 4: Pointer type (coarse = touch, fine = mouse)
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;

    // Check 5: Orientation API (real mobile devices have this)
    const hasOrientation = "orientation" in window;

    // Combine checks - require multiple indicators
    const userAgentMobile = mobileRegex.test(userAgent);

    // Real mobile typically has: coarse pointer + orientation + touch
    const realMobileIndicators = hasCoarsePointer && hasOrientation && hasTouch;

    return userAgentMobile && realMobileIndicators;
  };
}
